import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { AuthorisationService } from '../../services/authorisation/authorisation.service';
import { Observable } from 'rxjs';
import { LoginRenderingService } from 'src/app/services/login/login-rendering.service';

@Injectable()

export class JwtInterceptor implements HttpInterceptor {
    constructor(public authService: AuthorisationService,private loginService:LoginRenderingService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let currentUser = this.loginService.currentUser;
        
        // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
      
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    'X-AUTH-TOKEN': `Bearer ${currentUser.token}`
                }
            });
        }
        return next.handle(request);
    }
}